import { useIncomingCallStore } from "@notifications/incomingCallStore";
import { useSoftphoneStore } from "@phone/softphone";
import { useOpenCall } from "@shell/navigation";
import { useRouterState } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

/** Mount inside the router. Clinic-wide call updates cannot identify which browser answered. */
export const AnsweredCallNavigation = () => {
  const answeredCallUuid = useSoftphoneStore((s) => s.answeredCallUuid);
  const inbound = useIncomingCallStore((s) =>
    s.calls.some(
      (call) => call.callUuid === answeredCallUuid && call.origin === "inbound",
    ),
  );
  if (!answeredCallUuid || !inbound) return null;
  return (
    <NavigateAnsweredCall key={answeredCallUuid} callUuid={answeredCallUuid} />
  );
};

const NavigateAnsweredCall = ({ callUuid }: { callUuid: string }) => {
  const callState = useSoftphoneStore((s) => s.call?.state);
  const location = useRouterState({ select: (s) => s.location });
  const locationHref = location.href;
  const startingHref = useRef(locationHref);
  const handled = useRef(false);
  const openCall = useOpenCall();

  useEffect(() => {
    if (handled.current) return;
    if (locationHref !== startingHref.current) {
      handled.current = true;
      return;
    }
    if (callState !== "active") return;
    if (
      location.pathname.startsWith("/display") &&
      !location.pathname.startsWith("/display/front-desk")
    )
      return;
    handled.current = true;
    openCall(callUuid);
  }, [callUuid, callState, location.pathname, locationHref, openCall]);

  return null;
};
